import { render, staticRenderFns } from "./transferView.vue?vue&type=template&id=4a4dd28e&scoped=true"
import script from "./transferView.vue?vue&type=script&lang=js"
export * from "./transferView.vue?vue&type=script&lang=js"
import style0 from "./transferView.vue?vue&type=style&index=0&id=4a4dd28e&prod&lang=less&scoped=true"
import style1 from "./transferView.vue?vue&type=style&index=1&id=4a4dd28e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4dd28e",
  null
  
)

export default component.exports